<template>
    <div class="Police">
        <div class="title">
            <span :class="{ active: activeIndex == 0 }" @click="activeIndex = 0">推送方式设置</span>
            <span :class="{ active: activeIndex == 1 }" @click="activeIndex = 1">推送人员设置</span>
        </div>
        <div class="PushMethod" v-if="activeIndex == 0">
            <div class="search">
                <el-input v-model="eventName" placeholder="请输入关键字" style="width:250px;display:inline-block"></el-input>
                <el-select v-model="level" placeholder="请选择">
                    <el-option v-for="item in checkList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <el-select v-model="eventClass" placeholder="请选择">
                    <el-option v-for="item in TYPE" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
                <span><el-checkbox v-model="configured">显示未配置事件</el-checkbox></span>
            </div>
            <div class="pressure">
                <div class="box" v-for="(item,index) in PushMethod" :key="index">
                    <div class="tt" @click="arrowDown(item)">
                        <i class="el-icon-arrow-right" v-if="!item.isactive"></i>
                        <i class="el-icon-arrow-down" v-else></i>
                        {{ item.groupName }}</div>
                    <div class="conent" v-if="item.alarmDetails != undefined&&item.alarmDetails.length>0&&item.isactive">
                        <el-table :data="item.alarmDetails" style="width: 100%">
                            <el-table-column prop="levelText" label="等级" align="left" width="80">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.configured==1">
                                        <span style="color:#FD4238" v-if="scope.row.level=='urgent'">{{ scope.row.levelText }}</span>
                                        <span style="color:#F5AA00" v-else-if="scope.row.level=='hiddenDanger'">{{ scope.row.levelText }}</span>
                                        <span style="color:#0D94FF" v-else-if="scope.row.level=='notice'">{{ scope.row.levelText }}</span>
                                    </span>
                                    <span v-else>
                                        <span style="color:#CCCCCC" >{{ scope.row.levelText }}</span>
                                    </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="eventName" label="事件名称" width="180">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.configured==1">{{ scope.row.eventName }}({{ scope.row.nameRemarks }})</span>
                                    <span v-else style="color:#CCCCCC">{{ scope.row.eventName }}({{ scope.row.nameRemarks }})</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="webNotice"
                                align="center"
                                label="web/小程序">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.webNotice" disabled @change="changeWebNotice(scope.row)"></el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="wechatNotice"
                                align="center"
                                label="公众号">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.wechatNotice" :disabled="scope.row.configured==0" @change="changeWebNotice(scope.row)"></el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column prop="address" align="center" label="短信">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.messageNotice" :disabled="scope.row.configured==0" @change="changeWebNotice(scope.row)"></el-checkbox>
                                </template>
                            </el-table-column>
                            <el-table-column prop="address" align="center" label="模板详情">
                                <template slot-scope="scope">
                                    <span style="color:#0D94FF;cursor: pointer;"
                                        @click="dialogControlFun(scope.row)">查看</span>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>

                <div class="" style="text-align:center;padding-top:13%" v-if="PushMethod.length==0"><img :src="require('../../assets/img/not_found_data.png')" alt="" /></div>
            </div>
        </div>
        <div class="PushPersonnel" v-if="activeIndex == 1">
            <div class="search">
                <el-input v-model="roleName" placeholder="请输入关键字" style="width:250px;display:inline-block"></el-input>
                <el-select v-model="roleId" placeholder="请选择">
                    <el-option v-for="item in IdentityOption" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="pressure">
                <div class="box" >
                    <div class="tt" @click="within=!within">
                        <i class="el-icon-arrow-right" v-if="!within"></i>
                        <i class="el-icon-arrow-down" v-else></i>
                        项目内成员</div>
                    <div class="conent" v-if="within">
                        <el-table :data="members" style="width: 100%">
                            <el-table-column prop="username" label="名称" align="center" width="170">
                            </el-table-column>
                            <el-table-column prop="roleName" align="center" label="身份">
                            </el-table-column>
                            <el-table-column prop="phone" align="center" label="手机号">
                            </el-table-column>
                            <el-table-column prop="pushed" align="center" label="是否推送">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.pushed" @change="changeMessageNotice(scope.row)"></el-checkbox>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
                <div class="box" >
                    <div class="tt" @click="administrators=!administrators">
                        <i class="el-icon-arrow-right" v-if="!administrators"></i>
                        <i class="el-icon-arrow-down" v-else></i>
                        超级管理员</div>
                    <div class="conent" v-if="administrators">
                        <el-table :data="administratorslist" style="width: 100%">
                            <el-table-column prop="username" label="名称" align="center" width="170">
                            </el-table-column>
                            <el-table-column prop="roleName" align="center" label="身份">
                            </el-table-column>
                            <el-table-column prop="phone" align="center" label="手机号">
                            </el-table-column>
                            <el-table-column prop="pushed" align="center" label="是否推送">
                                <template slot-scope="scope">
                                    <el-checkbox v-model="scope.row.pushed" @change="changeMessageNotice(scope.row)"></el-checkbox>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>
        </div>

        <el-dialog class="dialogControl" title="" :visible.sync="dialogControl" width="700px" :before-close="handleClose">
            <div class="cont">
                <div class="dialogtitle">事件模板信息</div>
                <p><span>事件名称：</span>{{detailInfo.eventName}}（{{detailInfo.nameRemarks}}）</p>
                <p><span>事件定义：</span>{{detailInfo.eventDescription}}</p>
                <p><span>报警等级：</span>{{detailInfo.levelText}}</p>
                <p><span>事件分类：</span>{{detailInfo.eventClassText}}</p>
                <p><span>告警原因：</span>{{detailInfo.alamReason}}</p>
                <p><span>解决建议：</span>{{detailInfo.suggest}}</p>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { log } from 'console';
import { alarmTemplate,templateDetail,templateUser,templatePushUser,noticeTypeUpdate } from "../../api/power";
export default {
    data() {
        return {
            within:true,
            administrators:false,
            configured: false, //显示未配置事件
            level: "",
            eventClass: "",
            eventName: "",
            alarmList: [],
            checkList: [{
                label: "全部报警等级",
                value: ""
            }, {
                label: "紧急",
                value: "urgent"
            }, {
                label: "隐患",
                value: "hiddenDanger"
            }, {
                label: "通知",
                value: "notice"
            }],
            TYPE: [{
                label: "全部事件类型",
                value: ""
            }, {
                label: "保护动作",
                value: "protections"
            }, {
                label: "故障报警",
                value: "fault"
            }, {
                label: "开关变位",
                value: "switchDisplacement"
            }, {
                label: "越限异常",
                value: "overrun"
            }, {
                label: "信息通报",
                value: "messageNotice"
            }, {
                label: "操作命令",
                value: "operation"
            }, {
                label: "其他告警",
                value: "other"
            }],
            roleId:"",
            roleName:"",
            IdentityOption:[{
                label: "全部身份权限",
                value: ""
            },{
                label: "超级管理员",
                value: -9999
            },{
                label: "企业管理员",
                value: 1
            },{
                label: "普通用户",
                value: 2
            }],
            activeIndex: 0,
            dialogControl: false,
            detailInfo:{},
            personnelList:[],
            personnelListCopy:[],
            alarmListCopy:[]
        }
    },
    computed:{
        updateDate(){
            return [this.configured,this.level,this.eventClass]
        },
        PushMethod(){
            let num = 0
            let news  = JSON.parse(JSON.stringify(this.alarmListCopy))
            let list = news.filter((e,i)=>{
                if(e.alarmDetails!=undefined){
                    e.alarmDetails = e.alarmDetails.filter(a=>a.eventName.indexOf(this.eventName)!==-1)
                    if(e.alarmDetails.length>0&&num==0){
                        num = 1
                        e.isactive = true
                    }
                }   
                return e
            })
            return list
        },
        members(){
            let data1 = JSON.parse(JSON.stringify(this.personnelListCopy.members));
            return  data1.filter(e=>e.username.indexOf(this.roleName)!==-1)
        },
        administratorslist(){
            let data2 = JSON.parse(JSON.stringify(this.personnelListCopy.administrators));
            return data2.filter(e=>e.username.indexOf(this.roleName)!==-1)
        }
    },
    watch:{
        updateDate(){
            this.getalarmTemplate()
        },
        roleId(){
            this.getTemplateUser()
        },
    },
    created() {
        this.getalarmTemplate()
        this.getTemplateUser()
    },
    methods: {
        async changeWebNotice(item){
            let obj = {
                projectId: this.$store.getters.projectId,
                templateId:item.templateId,
                wechatNotice:item.wechatNotice?1:0,
                webNotice:item.webNotice?1:0,
                messageNotice:item.messageNotice?1:0
            }
            let result = await noticeTypeUpdate(obj);
            if(result.data.status){
                this.$message.success('操作成功！');
            }else{
                this.$message.error(result.data.errMsg);
            }
        },
        async changeMessageNotice(item){
            let obj = {
                projectId: this.$store.getters.projectId,
                pushed:item.pushed?1:0,
                userId:item.userId
            }
            let result = await templatePushUser(obj);
            if(result.data.status){
                this.$message.success('操作成功！');
            }else{
                this.$message.error(result.data.errMsg);
            }
        },
        async dialogControlFun(item){
            // let obj = {
            //     templateId: item.templateId
            // }
            // let result = await templateDetail(obj);
            this.detailInfo = item;
            this.dialogControl = true;
        },
        arrowDown(item){
            item.isactive = !item.isactive
            this.$forceUpdate();
        },
        handleClose() {
            this.dialogControl = false
        },
        async getalarmTemplate() {
            let obj = {
                projectId: this.$store.getters.projectId,
                configured: this.configured ? 1 : 0,
                level: this.level,
                eventClass: this.eventClass,
                eventName: this.eventName,
                templateGroup: ""
            }
            let result = await alarmTemplate(obj);
            this.alarmList = result.data.data.map((e,i)=>{
                if(e.alarmDetails){
                    e.alarmDetails = e.alarmDetails.map(a=>
                    {
                        a.webNotice = a.webNotice==1?true:false;
                        a.wechatNotice = a.wechatNotice==1?true:false;
                        a.messageNotice = a.messageNotice==1?true:false;
                        return a
                    }
                    )
                }
                if(i==0){
                    e.isactive = true
                }else{
                    e.isactive = false
                }
                return e
            })
            this.alarmListCopy = this.alarmList
        },
        async getTemplateUser() {
            let obj = {
                projectId: this.$store.getters.projectId,
                username: "",
                roleId:this.roleId
            }
            let result = await templateUser(obj);
            let data = result.data.data
            let members = []
            if(data.members){
                members = data.members.map(e=>{
                    e.pushed = e.pushed==1?true:false;
                    return e
                })
            }
            let administrators = []
            if(data.administrators){
                administrators = data.administrators.map(e=>{
                    e.pushed = e.pushed==1?true:false;
                    return e
                })
            }
            this.personnelList = {
                "members":members,
                "administrators":administrators
            }
            this.personnelListCopy = this.personnelList
        }
    }
}
</script>
<style lang="less" scoped>
.PushMethod,.PushPersonnel {
    height: calc(100% - 50px);
}


/deep/.dialogControl {
    .el-dialog__header {
        padding: 0;
    }

    .cont {
        padding: 15px 20px;

        .dialogtitle {
            border-left: 3px solid #0D94FF;
            font-size: 20rem;
            font-weight: bold;
            padding-left: 8px;
            height: 20px;
            line-height: 20px;
            margin-bottom: 20px;
        }

        p {
            line-height: 34px;
            color: #666666;
            font-size: 20rem;
            span {
                color: #333333;
            }
        }
    }
}

/deep/.el-table {
    .has-gutter {
        th {
            background: rgba(0, 43, 102, 0.06);
            // height: 64rem;
            // padding: 0;
            color: #333333;
            font-weight: 400;
        }
    }
}

/deep/.el-table td {
    border: 0 !important;
}

.pressure {
    height: calc(100% - 85px);
    overflow: auto;

    .box {
        margin-bottom: 2px;

        .tt {
            background: rgba(0, 43, 102, 0.2);
            height: 40px;
            line-height: 40px;
            font-size: 18rem;
            padding: 0 10px;
            cursor: pointer;

            .el-icon-arrow-down,.el-icon-arrow-right {
                font-weight: bold;
                margin-right: 5px;
            }
        }

        .conent {}
    }
}

.Police {
    background: #FFFFFF;
    height: 100%;

    .title {
        height: 64rem;
        line-height: 62rem;
        border-bottom: 1px solid #CCCCCC;
        font-size: 16px;
        padding: 0 30rem;

        span {
            margin-right: 40px;
            cursor: pointer;
            display: inline-block;
        }

        .active {
            border-bottom: 3px solid #0D94FF;
        }
    }

    .search {
        padding: 20px 30px;

        .el-select {
            margin-left: 10px;
        }

        span {
            float: right;
            line-height: 30px;
            display: inline-block;
        }

    }
}
</style>